import { IScope, IQService, IRootScopeService, ITimeoutService } from "angular";
import { StateService } from "@uirouter/angularjs";
import { IUser, IPatchedUser } from "@gtmhub/users/models";
import { AccountService } from "@gtmhub/accounts/accounts-service";
import { UserService } from "@gtmhub/users/userService";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { hasCurrentUserRole } from "@gtmhub/users";

interface IEditUserLicenseStateParams {
  id: string;
}

interface IIndicators {
  loading: boolean;
  saving: boolean;
}

interface IEditUserLicenseScope extends IScope {
  user: IUser;
  licenseTypes: string[];
  origSubscriptionType: string;
  indicators: IIndicators;
  isAdmin: boolean;
  editLicense(licenseType: string): void;
  save(): void;
}

export class EditUserLicenseCtrl {
  public static $inject = ["AccountService", "$q", "$rootScope", "$scope", "$state", "$stateParams", "$timeout", "UserService", "UIErrorHandlingService"];

  constructor(
    private accountService: AccountService,
    private $q: IQService,
    private $rootScope: IRootScopeService,
    private $scope: IEditUserLicenseScope,
    private $state: StateService,
    private $stateParams: IEditUserLicenseStateParams,
    private $timeout: ITimeoutService,
    private userService: UserService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    this.$scope.licenseTypes = [];
    this.$scope.indicators = {
      loading: true,
      saving: false,
    };
    this.$scope.save = this.save;
    this.$scope.isAdmin = hasCurrentUserRole("admin");
    this.$scope.editLicense = this.editLicense;

    this.init();
  }

  private init = () => {
    const UserAndSubscriptionsPromise = this.$q.all({
      user: this.userService.getUser(this.$stateParams.id),
      subscription: this.accountService.getSubscription(),
    });

    UserAndSubscriptionsPromise.then(
      ({ subscription, user }) => {
        this.$scope.indicators.loading = false;

        if (subscription && user) {
          this.$scope.licenseTypes = subscription.items.map((license) => license.type);
          this.$scope.user = user;
          this.$scope.origSubscriptionType = user.subscriptionType;
        }
      },
      (error) => this.handleErrors(error, "loading")
    );
  };

  private editLicense = (licenseType: string) => {
    this.$scope.user.subscriptionType = licenseType;
  };

  private save = () => {
    this.$scope.indicators.saving = true;

    const patchedUser: IPatchedUser = {
      subscriptionType: this.$scope.user.subscriptionType,
    };

    this.userService.patchUser(this.$scope.user.id, patchedUser).then(
      () => {
        this.$scope.origSubscriptionType = this.$scope.user.subscriptionType;
        this.$scope.indicators.saving = false;

        // done so that user can see that change was successful before modal is closed
        this.$timeout(() => {
          this.$rootScope.$broadcast("userSubscriptionUpdated", {
            id: this.$scope.user.id,
            subscriptionType: this.$scope.user.subscriptionType,
          });

          this.$state.go("^.^");
        }, 500);
      },
      (error) => this.handleErrors(error, "saving")
    );
  };

  private handleErrors = <Е>(error: Е, indicator: string) => {
    this.uiErrorHandlingService.handleIndicator(error, { indicator, inline: true });
  };
}
